import { Field, FieldRenderProps, useForm } from "react-final-form";
import "../Pricing.scss";
import "../i18n";
import { AssuredFormProps } from "./types";
import { useTranslation } from "react-i18next";
import { NumericInput } from "component/inputs/NumericInput";
import { useCallback } from "react";
import { ToggleSwitch } from "@pickit/pickit-components";

const AssuredForm = ({
  disableForm,
  testId,
  isEnabled,
  setIsEnabled,
}: AssuredFormProps): JSX.Element => {
  const { t } = useTranslation("polygonPricing");
  const mutators = useForm().mutators;

  const renderInput = useCallback(
    (
      props: FieldRenderProps<HTMLElement>,
      type: "price" | "percentage",
      testId?: string
    ) => {
      return (
        <div className="pesos-input-container">
          <p
            className={[
              "pesos-placeholder",
              props?.meta?.error && props?.meta?.touched && "error",
              type === "percentage" && "percentage",
            ].join(" ")}
            data-testId={`${testId}-currency`}
          >
            {type === "price" ? t("divisa") : "%"}
          </p>
          <NumericInput {...props} testId={testId} />
        </div>
      );
    },
    [t]
  );

  return (
    <div className="pricing-form-container">
      <div className="assured-title">
        <h2 className="subTitle-pending">
          <p className="subtitle-pricing-h3" data-testId={`${testId}-title`}>
            {t("assuredTitle")}
          </p>
        </h2>
        <ToggleSwitch
          value={isEnabled}
          onChange={() => {
            setIsEnabled((prev) => !prev);
            mutators.resetAssured();
          }}
          disabled={disableForm}
        />
      </div>
      <div className="container-fluid pricing-container">
        <div className="container-pricing-col">
          <div className="container-row">
            <div className="container-pricing-col-sm-5 container-pricing-col-xl-3">
              <Field
                name="assured.amountPerHour"
                label={t("assuredValue")}
                className="Admin-Pickers-input"
                placeholder={"-"}
                maxDecimal={2}
                maxInt={5}
                allowDecimal
                disabled={disableForm || !isEnabled}
              >
                {(props) => renderInput(props, "price", `${testId}-per-hour`)}
              </Field>
            </div>
            <div className="container-pricing-col-sm-5 container-pricing-col-xl-3">
              <Field
                name="assured.presenteeism"
                label={t("presenteeism")}
                className="Admin-Pickers-input"
                placeholder={"-"}
                maxInt={3}
                disabled={disableForm || !isEnabled}
                allowDecimal={false}
              >
                {(props) =>
                  renderInput(props, "percentage", `${testId}-presenteeism`)
                }
              </Field>
            </div>
            <div className="container-pricing-col-sm-5 container-pricing-col-xl-3">
              <Field
                name="assured.minimumAmount"
                label={t("minimumAmount")}
                className="Admin-Pickers-input"
                placeholder={"-"}
                disabled={disableForm || !isEnabled}
                maxInt={4}
                allowDecimal={false}
              >
                {(props) => (
                  <NumericInput {...props} testId={`${testId}-min-amount`} />
                )}
              </Field>
            </div>
            <div className="container-pricing-col-sm-5 container-pricing-col-xl-3">
              <Field
                name="assured.minimumPercentage"
                label={t("minimumPercentage")}
                className="Admin-Pickers-input"
                placeholder={"-"}
                maxInt={3}
                disabled={disableForm || !isEnabled}
                allowDecimal={false}
              >
                {(props) =>
                  renderInput(props, "percentage", `${testId}-min-percentage`)
                }
              </Field>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AssuredForm;
